import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ApiError, AuthService, UserDetail, UserPendingNotifications } from '../../api';
import { userQueryKeys } from '../query-keys-factories/user';

export const useCurrentUser = (
  queryOptions: Omit<
    UseQueryOptions<UserDetail, ApiError, UserDetail, string[]>,
    'queryKey' | 'queryFn'
  > = {}
) => {
  const {
    data: user,
    error: errors,
    ...rest
  } = useQuery({
    queryKey: userQueryKeys.detail('current'),
    queryFn: () => AuthService.authUserRetrieve(),
    retry: false,
    ...queryOptions,
  });

  return {
    user,
    errors,
    ...rest,
  };
};

export const useCurrentUserNotifications = (
  queryOptions: Omit<
    UseQueryOptions<UserPendingNotifications, ApiError, UserPendingNotifications, string[]>,
    'queryKey' | 'queryFn'
  > = {}
) => {
  const {
    data: notifications,
    error: errors,
    ...rest
  } = useQuery({
    queryKey: userQueryKeys.notifications(),
    queryFn: () => {
      return AuthService.authUserNotificationsRetrieve();
    },
    ...queryOptions,
  });

  return {
    notifications,
    errors,
    ...rest,
  };
};
